import React from 'react';
import Icon from '../../../components/AppIcon';

const AchievementBadge = ({ 
  title, 
  description, 
  icon = 'Award',
  date,
  rarity = 'common'
}) => {
  const getRarityConfig = () => {
    switch (rarity) {
      case 'legendary':
        return {
          bgGradient: 'from-yellow-500/20 to-orange-500/20',
          borderColor: 'border-yellow-500/40',
          iconColor: 'var(--color-warning)',
          textColor: 'text-warning'
        };
      case 'epic':
        return {
          bgGradient: 'from-purple-500/20 to-pink-500/20',
          borderColor: 'border-purple-500/40',
          iconColor: '#A855F7',
          textColor: 'text-purple-500'
        };
      case 'rare':
        return {
          bgGradient: 'from-blue-500/20 to-cyan-500/20',
          borderColor: 'border-blue-500/40',
          iconColor: 'var(--color-primary)',
          textColor: 'text-primary'
        };
      default:
        return {
          bgGradient: 'from-muted/50 to-muted/30',
          borderColor: 'border-border',
          iconColor: 'var(--color-muted-foreground)',
          textColor: 'text-muted-foreground'
        };
    }
  };

  const config = getRarityConfig();

  return (
    <div className={`
      bg-gradient-to-br ${config?.bgGradient} border ${config?.borderColor}
      rounded-lg p-4 hover-lift transition-smooth
    `}>
      <div className="flex items-start gap-3">
        <div className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full bg-card shadow-md">
          <Icon name={icon} size={24} color={config?.iconColor} strokeWidth={2.5} />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm md:text-base font-heading font-semibold text-foreground mb-1">
            {title}
          </h4>
          <p className="text-xs md:text-sm caption text-muted-foreground mb-2 line-clamp-2">
            {description}
          </p>
          <div className="flex items-center gap-2">
            <span className={`text-xs font-semibold caption px-2 py-1 rounded ${config?.textColor} bg-card`}>
              {rarity?.charAt(0)?.toUpperCase() + rarity?.slice(1)}
            </span>
            <span className="text-xs caption text-muted-foreground">
              {date}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AchievementBadge;